export default __webpack_public_path__ + "static/media/graphic.95aa5af2.png";